export default {
  title: 'Biometric data verification',
  titleDescription: 'It is necessary to verify the identity of the beneficiary to continue',
  allowCamera: 'Allow access to the camera in your browser',
  tabs: {
    facial: 'Facial recognition'
  },
  buttons: {
    capture: 'Capture',
    retry: 'Try again',
    confirm: 'Confirm'
  },
  biometricValidation: {
    success: 'Successful verification',
    fail: 'Verification failed'
  },
  instructions: {
    title: 'Biometric data of the beneficiary',
    subtitle: 'It is necessary to capture the person\'s face to verify their identity',
    buttonLabel: 'Start',
    steps: {
      step1: {
        title: 'Step 1',
        description: 'Place the camera at the level of the insured\'s face'
      },
      step2: {
        title: 'Step 2',
        description: 'Make sure there is enough light'
      },
      step3: {
        title: 'Step 3',
        description: 'Frame the face within the limits shown'
      }
    }
  }
}